import { useTranslation } from 'react-i18next';
import { InfoCard, CardWrapper } from '../index';
import { VacancyBuildingDto } from '@client/api';
import { NoDataWidget } from '../../../dashboard-basic-view/components/NoDataWidget/no-data-widget';
interface VacancyListCardProps {
  topBuildings: VacancyBuildingDto[];
}

export const VacancyListCard = ({ topBuildings }: VacancyListCardProps) => {
  const { t } = useTranslation('widget');
  if (!topBuildings.length) {
    return <NoDataWidget title={t('vacancyCost.listTitle', { count: 5 })} noDataText={t('vacancyCost.noData')} />;
  }
  return (
    <CardWrapper title={t('vacancyCost.listTitle', { count: topBuildings.length })}>
      {topBuildings.map((building) => (
        <InfoCard
          key={building.buildingId}
          name={building.buildingName}
          amount={building.vacancyCost.value}
          chipLabel={t('vacancyCost.chipLabel', { monthsFree: building.durationInMonths })}
          chipColor={'#91CBFB'}
        />
      ))}
    </CardWrapper>
  );
};
